import React from "react";

const LightGalleryIcon32x32 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
    <defs>
      <filter id="a" width="50" height="50" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset dy="3" />
        <feGaussianBlur result="blur" stdDeviation="3" />
        <feFlood floodOpacity=".322" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g data-name="gallery icon 32px-light">
      <g filter="url(#a)">
        <circle cx="16" cy="16" r="16" data-name="Ellipse 68" transform="translate(9 6)" fill="#fff" opacity=".8" />
      </g>
      <path
        d="M31 27v.5a1.5 1.5 0 01-1.5 1.5h-12a1.5 1.5 0 01-1.5-1.5v-8a1.5 1.5 0 011.5-1.5h.5v6.5a2.5 2.5 0 002.5 2.5zm3-2.5v-8a1.5 1.5 0 00-1.5-1.5h-12a1.5 1.5 0 00-1.5 1.5v8a1.5 1.5 0 001.5 1.5h12a1.5 1.5 0 001.5-1.5zM24 18a1.5 1.5 0 11-1.5-1.5A1.5 1.5 0 0124 18zm-3 4.5l1.735-1.735a.374.374 0 01.53 0l1.234 1.234 4.235-4.234a.374.374 0 01.53 0L32 20.5V24H21z"
        data-name="Path 498"
        fill="#121212"
      />
    </g>
  </svg>
);

export default LightGalleryIcon32x32;
